import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Query } from '@apollo/client/react/components';
import { graphql } from '@apollo/client/react/hoc';
import { partial } from 'lodash';
import PropTypes from 'prop-types';
import timesheetsFooterAlertTimecardCount from 'schemas/queries/featureFlags/timesheetsFooterAlertTimecardCount.graphql';

import { showModal } from 'actions/modals';
import { createMonetizationCtaEvent } from 'actions/session';

import { TIMECARDS_COMPLIANCE_UPSELL_MODAL } from 'features/modals/constants';

import Box from 'components/Box';
import Button from 'components/clickables/Button';
import Icon from 'components/Icon';
import StickyBanner from 'components/StickyBanner';
import Text from 'components/Text';

import cxHelpers from 'util/className';
import { trackMonetizationCtaEventKinesis } from 'util/tracking';
import {
  TRACK_ACTIONS,
  TRACK_EVENTS,
  TRACK_SOURCES,
} from 'util/tracking_constants';

@graphql(timesheetsFooterAlertTimecardCount, {
  options: () => ({
    fetchPolicy: 'cache-first',
  }),
})
@connect(() => ({}), {
  showModal,
  createMonetizationCtaEvent,
})
@cxHelpers('TimesheetsFooterAlert')
export default class TimesheetsFooterAlert extends PureComponent {
  static propTypes = {
    showModal: PropTypes.func.isRequired,
    createMonetizationCtaEvent: PropTypes.func.isRequired,
  };

  state = {
    isVisible: true,
  };

  componentDidMount() {
    this.trackEvent(`${TRACK_ACTIONS.VIEW}_b`);
    this.props.createMonetizationCtaEvent(TRACK_EVENTS.TIMESHEETS_FOOTER_ALERT);
  }

  trackEvent = (actionType, properties = {}) =>
    trackMonetizationCtaEventKinesis(
      TRACK_EVENTS.MONETIZATION_UPSELL_ON_TIMESHEET_COMPLIANCE,
      actionType,
      {
        source: TRACK_SOURCES.BANNER,
        ...properties,
      }
    );

  trackAndCloseComplianceModal = onHideModal => {
    this.trackEvent(TRACK_ACTIONS.CLICKED_CLOSED, {
      source: TRACK_SOURCES.MODAL,
    });
    onHideModal();
  };

  handleClose = ({ track = true }) => {
    if (track) this.trackEvent(TRACK_ACTIONS.CLICKED_CLOSED);

    this.setState({ isVisible: false });
  };

  handleClickLearnMore = timecardsCount => {
    this.trackEvent(`${TRACK_ACTIONS.CLICKED_LEARN_MORE}_b`);
    this.handleClose({ track: false });
    this.props.showModal(TIMECARDS_COMPLIANCE_UPSELL_MODAL, {
      deprecatedModal: true,
      auto: true,
      noPadding: true,
      onClose: this.trackAndCloseComplianceModal,
      timecardsCount,
    });
  };

  render() {
    if (!this.state.isVisible) return null;

    return (
      <Query query={timesheetsFooterAlertTimecardCount}>
        {({ data }) => {
          if (!data) return null;

          const timecardsCount = data.timesheetsFooterAlertTimecardCount;

          if (!timecardsCount) return null;

          return (
            <Box className={this.cx()}>
              <StickyBanner
                type="error"
                onClose={this.handleClose}
                closeIconProps={{ color: 'red' }}
              >
                <Box row vcenter hcenter w="100%">
                  <Box mr12>
                    <Icon size="md" type="bang" />
                  </Box>
                  <Button
                    theme="link-red"
                    onClick={partial(this.handleClickLearnMore, timecardsCount)}
                  >
                    <Text
                      className={this.cxEl('b')}
                      asHTML
                      fw600
                      i18n="timesheets.footer_alert.message_b"
                      i18nProps={{ count: timecardsCount }}
                    />
                  </Button>
                </Box>
              </StickyBanner>
            </Box>
          );
        }}
      </Query>
    );
  }
}
